import { render } from "./ProductSellorder.vue?vue&type=template&id=044c1c71"
import script from "./ProductSellorder.vue?vue&type=script&lang=js"
export * from "./ProductSellorder.vue?vue&type=script&lang=js"

import "./ProductSellorder.vue?vue&type=style&index=0&id=044c1c71&lang=css"
script.render = render

export default script